"use client";

import { useBackend } from ".";
import { useSessionToken } from "../useSessionToken";

export default function useClientBackend() {
  try {
    const { sessionToken } = useSessionToken();

    return useBackend(sessionToken ?? undefined);
  } catch {
    return useBackend(undefined);
  }
}
